const formats = {
  number: {
    AUD: {
      style: 'currency',
      currency: 'AUD',
      currencyDisplay: 'symbol',
    },
    USD: {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'symbol',
    },
  },
  date: {
    short: {
      month: 'short',
      day: 'numeric',
      weekday: 'short',
    },
  },
};

export default formats;
